import type { FaireProductEntity } from "../../entity_types/product";

export const p_afnqacsc7v: FaireProductEntity = {
  token: "p_afnqacsc7v",
  type: "product",
  name: "Crush Pineapple 2/12pk/12oz",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/c6c6fc784672024deeea0c97f40660f88d76a141bf9fe5bfe34a6ce1bb3b0ee9.jpeg",
  galleryImageUrls: [],
  priceDollars: 31.87,
  description:
    "Pineapple Crush with tropical flavor and exotic appeal, ideal for customers seeking unique fruit soda experiences.",
  tags: [],
  msrpDollars: 63.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:36.569Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
